import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {
    render({ name, label, value, dirty, error }) {
        return (
            <name-field>
                <label htmlFor={label} class={dirty && error ? 'error' : ''}>
                    {label}
                    {this.renderInfo()}
                    <input
                      maxLength='40'
                      type='text'
                      name={name}
                      value={value}
                      onKeyUp={this.validate}
                      required
                    />
                    {this.renderError()}
                </label>
            </name-field>
        );
    }

    renderInfo = () => {
        if (this.props.info) {
            return (
                <span class='more-info text-link'>
                    More info
                    <span class='form-tooltip'>{this.props.info}</span>
                </span>
            );
        }

        return null;
    }

    renderError = () => {
        if (this.props.dirty && this.props.error) {
            return (
                <p class='error-msg'>{this.props.error}</p>
            );
        }

        return (
            <p class='error-msg' />
        );
    }

    validate = (e) => {
        const value = e.target.value;
        const name = e.target.getAttribute('name');
        const number_of_values = value.replace(/[^\s]+/g, '').length + 1;
        let error = null;

        if (number_of_values == 0) {
            error = "This field can't be empty.";
        } else if (number_of_values == 1) {
            error = 'This field requires at least first and last names.';
        } else if (number_of_values > 3) {
            error = 'This field requires first and last name. Middle name is optional';
        }

        this.props.reportInput(name, value, error);
    }

}

export default connect()(Component);



// WEBPACK FOOTER //
// ./app/components/fields/name.js